<template>
    <div class="evaluate">
        <span class="btn-close" @click="handleClose"><svg-icon icon-class="close"></svg-icon></span>
        <div class="evaluate-container">
            <div>历史评价记录：<span class="visitorName" >{{visitorName}}</span></div>
            <div class="evaluate-record-table">
                <el-table
                        :data="tableData"
                        v-loading="tableLoading"
                        height="70%"
                        :header-cell-style="{background:'#f2f2f2'}"
                        border
                        style="width: 100%;font-size: 12px;">
                    <el-table-column
                            label="接待客服"
                            width="180">
                        <template slot-scope="scope">
                            <div class="service-info">
                                <div class="service-avatar">
                                    <img :src="avatarM(scope.row.csHeadimg)" alt="">
                                </div>
                                <div class="service-name">{{scope.row.servicerName}}</div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="evaluateTimeStr"
                            label="评价时间"
                            width="160">
                    </el-table-column>
                    <el-table-column
                            width="150"
                            label="满意度">
                        <template slot-scope="scope">
                            <el-rate disabled disabled-void-color="#ddd" score-template="{value}"
                                     v-model="scope.row.evaluateGrade"
                            ></el-rate>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="evaluateContent"
                            label="评价内容">
                        <template slot-scope="scope">
                            <div class="evaluate-content">
                                {{scope.row.evaluateContent ? scope.row.evaluateContent : '--'}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="evaluateContent"
                            label="评价标签">
                        <template slot-scope="scope">
                            <span v-for="(item, index) in scope.row.evaluateTags" style="padding: 2px 8px;background: #4ca0ff;color: #fff;margin:0 8px 8px 0;display: inline-block;font-size: 12px;border-radius: 4px;">{{item}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <pagenations
                        :total="total"
                        :size="pageSize"
                        @pageHandler="pageOperate">
                </pagenations>
            </div>
        </div>
    </div>
</template>

<script>
    import pagenations from '@/components/pagenations/pagenations'

    import avatar0 from '@/assets/images/client_avatar_empty.png'

    export default {
        props:['evaluateData'],
        name: "evaluate",
        components:{
            pagenations
        },
        data() {
            return {
                evaluateRecord:{},
                visitorId:'',
                visitorName:'',
                tableData:[],
                total:0,
                pageSize:10,
                pageNum:1,
                tableLoading:false
            }
        },
        watch:{
            'evaluateData'(){
                this.visitorId = this.evaluateData.onlineVisitorEntity.visitorId
                this.visitorName = this.evaluateData.onlineVisitorEntity.visitorName
                this.evaluateRecord = this.evaluateData
                this.getEvaluateData()
            }
        },
        created() {
            this.evaluateRecord = this.evaluateData
            this.visitorId = this.evaluateData.onlineVisitorEntity.visitorId
            this.visitorName = this.evaluateData.onlineVisitorEntity.visitorName
            this.getEvaluateData()
        },
        mounted() {
        },
        methods: {
            handleClose(){
                this.$emit('evaluateShowHandler', false)
            },
            pageOperate(val){
                if (val.type == 'currentChange') {
                    this.pageNum = val.val
                } else if (val.type == "sizeChange") {
                    this.pageSize = val.val
                }
                this.getEvaluateData()
            },
            /**
             * 【显示客服头像】
             */
            avatarM(avatar) {
                let reg = new RegExp(/(http|https):\/\/([\w.]+\/?)\S*/, 'g')
                if (reg.test(avatar)) {
                    return avatar;
                } else {
                    return avatar0
                }
            },
            getEvaluateData(){
                this.tableLoading = true
                this.$http.getEvaluateRecordListAPI({
                    visitorId:this.visitorId,
                    pageSize:this.pageSize,
                    pageNum:this.pageNum,
                }).then( res => {
                    if (res.status == 1) {
                        this.total = res.data.total
                        this.pageSize = res.data.pageSize
                        this.tableData = res.data.data
                    }
                    this.tableLoading = false
                }).catch( err => {
                    this.tableLoading = false
                })
            },
        },
    }
</script>

<style lang="scss">
    .evaluate {
        background-color: #F5F6F7;
        width: 100%;
        height: 100%;
        position: relative;
        .evaluate-container{
            padding: 15px;
            height: 100%;
            .visitorName{
                color: $mainColor;
            }
            .evaluate-record-table{
                height: 100%;
                padding-top: 20px;
                .service-info{
                    display: flex;
                    align-items: center;
                    .service-avatar{
                        width: 30px;
                        height: 30px;
                        img{
                            width: 100%;
                            height: 100%;
                            border-radius: 50%;
                        }
                        margin-right: 5px;
                    }
                    .service-name{
                        flex: 1;
                    }
                }
                .evaluate-content{
                }
            }
        }
    }
</style>